<template>
  <div>
    <!-- Summary
    -------------------------------------------------- -->
    <template v-if="isSummary">
      <div class="columns">
        <div class="column">
          <summary-item :amount="sellingInfo.sale_amount">Sale Amount</summary-item>
        </div>
        <div class="column">
          <summary-item
            :amount="record.actual_profit"
          >Actual Profit</summary-item>
        </div>
      </div>

      <info-item
        label="Inspect By Date"
        :value="sellingInfo.inspect_by_date"
        is-date
      ></info-item>

      <info-item
        label="Closed Date"
        :value="sellingInfo.closing_at"
        is-date
      ></info-item>
    </template>


    <!-- Expanded
    -------------------------------------------------- -->
    <template v-else>
      <h5 class="selling_status">Status <span>{{ sellingStatus }}</span></h5>
      <hr>

      <!-- Amounts -->
      <div> <!-- Need this div to allow css last-of-type to work -->
        <analysis-item
          label="Earnest Amount"
          :value="sellingInfo.earnest_amount"
        ></analysis-item>
        <analysis-item
          label="Earnest Money Deposited"
          :value="sellingInfo.earnest_money_deposited"
          is-boolean
        ></analysis-item>
        <analysis-item
          label="Sale Amount"
          :value="sellingInfo.sale_amount"
        ></analysis-item>
      </div>
      <hr>

      <!-- Actual Profit -->
      <profit-item
        type="Actual"
        :amount="record.actual_profit"
        hint="Actual Profit = Sale Amount - Latest Buying Offer"
      ></profit-item>
      <hr>

      <!-- Dates -->
      <info-heading heading="Dates"></info-heading>
      <info-item
        label="Inspect By Date"
        :value="sellingInfo.inspect_by_date"
        is-date
      ></info-item>
      <info-item
        label="Assigned Date"
        :value="sellingInfo.assigned_at"
        is-date
      ></info-item>
      <info-item
        label="Closed Date"
        :value="sellingInfo.closing_at"
        is-date
      ></info-item>
    </template>
  </div>
</template>

<script>
import AnalysisItem from "./AnalysisItem";
import ProfitItem from "./ProfitItem";
import InfoHeading from "./InfoHeading";
import InfoItem from "./InfoItem";
import {ENUMS} from "../../../services/enums";
import SummaryItem from "./SummaryItem";

export default {
  name: "SellingInfoWholesale",
  components: {
    SummaryItem,
    InfoItem,
    InfoHeading,
    ProfitItem,
    AnalysisItem
  },
  props: {
    sellingInfo: {
      type: Object,
      required: true
    },
    isSummary: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    record() {
      return this.$store.state.activeRecord.record;
    },
    sellingStatus() {
      if(this.sellingInfo && this.sellingInfo.status) {
        return this.$utils.newGetEnumLabel(this.sellingInfo.status, ENUMS.WholesaleSellingInfoStatusEnum);
      } else {
        return '--'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

hr {
  margin: 0.75rem (-$modalGutter);
}

.selling_status {
  margin-top: 8px;
  font-weight: bold;

  span {
    float: right;
  }
}
</style>
